import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import {
    CTI_COLUMN,
    DEFAULT_COLUMN,
    DEFAULT_VA_COLUMN,
    PURCHASES_FORECAST_MODULE,
} from "../constant/purchasesReceiptConstant";

const subDomain = window.location.host.split('.')[0];
const forecastColumns = (): Column[] => {
    if (subDomain === 'valeurs-assurances') return DEFAULT_VA_COLUMN;
    if (subDomain === 'continents-insolites' || subDomain === 'tourist-forum') return CTI_COLUMN;
    return DEFAULT_COLUMN;
};

export const setPurchasesReceiptForecastPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: PURCHASES_FORECAST_MODULE,
        default_columns: forecastColumns(),
        default_order_by: '',
        default_order: 'asc',
    });
